import React, { useEffect } from 'react'
import Layout from '../components/Layout'
import "../stylings/contact.css"
import { useDispatch } from 'react-redux'
import { hideLoading, showLoading } from '../redux store/loader'
import { FaLocationDot, FaSquarePhone } from 'react-icons/fa6'
import { MdEmail } from 'react-icons/md'

const ContactUs = () => {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(showLoading());
        setTimeout(() => {
            dispatch(hideLoading())
        }, [1700])
    }, [])


    return (
        <Layout>
            <div className="contactus container">
                <h3 className='title'>
                    <div className='word-leader'>CONTACT</div>
                    <div>INFORMATION</div>
                </h3>
                <div className="seprator-line-wrapper">
                    <span className="seprator-one"></span>
                    <span className="seprator-two"></span>
                </div>
                <div className="row">
                    <div className="column col-sm-6">
                        <h4 className='sub-title'>Get In Touch</h4>
                        <div className="contact-us-wrapper">
                            <ul>
                                <li>
                                    <span className='connector-line'></span>
                                    <div className="box-wrapper">
                                        <div className="svg-container">
                                            <FaSquarePhone />
                                        </div>
                                        <div className="info-wrapper">
                                            <h6 className="sub-title">
                                                Phone Number
                                            </h6>
                                            <p>+91-8595015369</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <span className='connector-line'></span>
                                    <div className="box-wrapper">
                                        <div className="svg-container">
                                            <MdEmail />
                                        </div>
                                        <div className="info-wrapper">
                                            <h6 className="sub-title">
                                                Email
                                            </h6>
                                            <p>wtlfoundation91@gmail.com</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <span className='connector-line'></span>
                                    <div className="box-wrapper">
                                        <div className="svg-container">
                                            <FaLocationDot />
                                        </div>
                                        <div className="info-wrapper">
                                            <h6 className="sub-title">
                                                Address
                                            </h6>
                                            <p>Phase 6, Aya Nagar Delhi - 110047</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="column col-sm-6">
                        <div className="img-container h-100">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7956.640472399027!2d77.12742435835999!3d28.471951402786097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1f1a4c17218f%3A0x4d0d31ef5670ca05!2sWay%2CTruth%20and%20Life%20Foundation%20School!5e0!3m2!1sen!2sin!4v1751050696484!5m2!1sen!2sin"
                                style={{
                                    style: "border:0;", allowfullscreen: "", loading: "lazy",
                                    referrerpolicy: "no-referrer-when-downgrade",
                                    width: "100%", height:"100%"
                                }} className='google-map'>
                                    
                                </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ContactUs
